<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg"><img src="assets/svg/task-icon-orange.svg" alt=""></div>
      <div>
        <h4 class="text-semibold">
          Cambiar {{ mode === 'estado' ? 'estado' : 'prioridad' }}
        </h4>
        <h6 class="color-gray" style="font-weight: 400;">
          Selecciona {{ mode === 'estado' ? 'el estado actual' : 'la prioridad actual' }} de la tarea
        </h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img class="close-button" src="assets/svg/close-icon.svg" (click)="closemodal()" alt="">
          </div>
        </h3>
      </div>
    </div>

    <div class="mdl-body">
      <!-- Sección ESTADO -->
      <div class="mt-3" *ngIf="mode === 'estado'">
        <label class="login-label" for="estado">* Estado:</label>
        <div style="border: solid 1px #D9D9D9; padding: 4px 10px;">
          <div class="d-grid crm-ng-select">
            <div><img src="assets/svg/task-icon.svg" alt="icono estado"></div>
            <div>
              <ng-select class="crm-ng-select"
                [items]="estados"
                bindLabel="label"
                bindValue="value"
                placeholder="Selecciona el estado de la tarea"
                [(ngModel)]="selectedEstado"
                [searchable]="false"
                [clearable]="false">
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección PRIORIDAD -->
      <div class="mt-3" *ngIf="mode === 'prioridad'">
        <label class="login-label" for="prioridad">* Prioridad:</label>
        <div style="border: solid 1px #D9D9D9; padding: 4px 10px;">
          <div class="d-grid crm-ng-select">
            <div><img src="assets/svg/task-icon.svg" alt="icono prioridad"></div>
            <div>
              <ng-select class="crm-ng-select"
                [items]="prioridades"
                bindLabel="label"
                bindValue="value"
                placeholder="Selecciona la prioridad de la tarea"
                [(ngModel)]="selectedPrioridad"
                [searchable]="false"
                [clearable]="false">
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-4">
      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button class="btn btn-primary-outline" (click)="closemodal()">Cancelar</button>
        <button class="btn btn-primary" (click)="saveChanges()">Guardar</button>
      </div>
    </div>
  </div>
</div>
